module.exports = __webpack_public_path__ + "2e2bf7d2962c0a54b12327928a009c70.svg";


//////////////////
// WEBPACK FOOTER
// ./Content/icons/sets/board-icons.svg
// module id = ./Content/icons/sets/board-icons.svg
// module chunks = 8